import React from "react";
import { Grid, Paper } from "@material-ui/core";

export const CenteredContainer: React.FC = ({ children }) => {
  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: "100vh" }}
    >
      <Grid item xs={4}>
        <Paper elevation={0}>{children}</Paper>
      </Grid>
    </Grid>
  );
};
